<template>
  <div class="entity">
    <div class="entity__main">
      <div>
        <v-progress-circular
          v-if="
            $loading.isLoading([
              `removeAssignment_${id}`,
              `createAssignment_${id}`,
            ])
          "
          indeterminate
          size="small"
          width="3"></v-progress-circular>
        <v-checkbox
          v-else-if="showChecked"
          :model-value="isCheckedEntity"
          :readonly="readonly"
          single
          type="checkbox"
          hide-details
          @update:model-value="
            $event
              ? createAssignment({
                  entityId: entity.entityId,
                  entityTypeId: entity.entityTypeId,
                })
              : removeAssignment()
          "></v-checkbox>
      </div>

      <span class="entity__icon">
        <span
          v-if="entity.typeId === 1 || entity.typeId === void [0]"
          :style="style"
          class="entity__icon-user">
          <BaseImage
            :class="{ showDefaultIcon: !entity.photo }"
            :src="entity.photo"
            alt="user-icon"
            onerror="this.classList.add('showDefaultIcon')"
            rounded
            width="42" />
          <i :style="style" class="defaultIcon pi pi-user"></i>
        </span>
        <i v-else :class="entity.photo" :style="style"></i>
      </span>
      <span class="entity__text">
        <span class="entity__name">{{ entity.name }}</span>
        <br />
        <span class="entity__description pl-1">{{
          getEntityDescription(entity)
        }}</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue'
import { useAcknowledgment } from './index'
import { generateId } from 'best-modules/utils'
import { handleAsync } from 'best-modules/plugins'

export default {
  emits: ['delete'],
  props: {
    entity: { type: Object, required: true },
    showChecked: { type: Boolean },
    readonly: { type: Boolean },
    size: { type: String, default: '3rem' },
  },
  setup(props) {
    const id = generateId()

    const {
      createAssignment: ca,
      removeAssignment: rm,
      findAssignmentByEntity,
    } = useAcknowledgment()
    const style = computed(() => {
      return `width:${props.size};height:${props.size};font-size:${props.size}`
    })

    const getUserDescription = (user: any) => {
      if ('department' in user) {
        const department = user.department?.name || 'Департамент не вказано'
        const post = user.post || 'Посаду не вказано'

        return `${department} (${post})`
      }
      return null
    }

    const getEntityDescription = (entity: any) => {
      return entity.description || getUserDescription(entity) || 'Группа'
    }

    const isCheckedEntity = computed<boolean>(() => {
      if (!props.showChecked) {
        return false
      } else {
        return !!findAssignmentByEntity(
          props.entity.entityTypeId,
          props.entity.entityId
        )
      }
    })

    const createAssignment = (assigneeEntity: {
      entityTypeId: number
      entityId: number
    }) => {
      return handleAsync(`createAssignment_${id}`, () => {
        return ca(assigneeEntity)
      })
    }

    const removeAssignment = () => {
      return handleAsync(`removeAssignment_${id}`, () => {
        const assignment = findAssignmentByEntity(
          props.entity.entityTypeId,
          props.entity.entityId
        )
        return rm(assignment.id)
      })
    }

    return {
      id,
      style,
      getEntityDescription,
      isCheckedEntity,
      createAssignment,
      removeAssignment,
    }
  },
}
</script>

<style lang="scss" scoped>
.entity {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 5px;

  &:hover {
    background: #00000014;
  }

  & * {
    display: inline-block;
  }

  &__main {
    display: flex;
    align-items: center;
    //gap: 1rem;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    & i {
      transform: scale(0.7);
    }

    &-user {
      & img {
        margin: 0 auto;
      }
    }
  }

  &__text {
    margin-left: 1rem;
  }

  &__name {
    font-size: 14px;
  }

  &__description {
    color: var(--gray-500);
  }

  &__delete {
    margin-left: 1rem;
  }
}
</style>
